"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ConvertPlaceholder = exports.ConvertConfirm = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _formik = require("formik");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var Yup = _interopRequireWildcard(require("yup"));
var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));
var _FormErrorMessage = _interopRequireDefault(require("../../../../components/FormErrorMessage"));
var _Button = _interopRequireDefault(require("../../../../components/Button"));
var _InputWithDomain = _interopRequireDefault(require("./InputWithDomain"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ConvertForm = function ConvertForm(_ref) {
  var title = _ref.title,
    description = _ref.description,
    warning = _ref.warning,
    domain = _ref.domain,
    onClose = _ref.onClose,
    _onSubmit = _ref.onSubmit,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValue: {
      email: ''
    },
    validationSchema: Yup.object({
      email: Yup.string().trim().required(t('required'))
    }),
    onSubmit: function onSubmit(values, formikBag) {
      return _onSubmit(values.email, formikBag);
    },
    render: function render(_ref2) {
      var errors = _ref2.errors,
        dirty = _ref2.dirty,
        handleSubmit = _ref2.handleSubmit;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "p-8 bg-card"
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h4", {
        className: "text-2xl font-bold mb-3"
      }, title), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-xs text-gray-light"
      }, description), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-xs text-red mt-2"
      }, warning)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "py-8"
      }, /*#__PURE__*/_react["default"].createElement(_InputWithDomain["default"], {
        autoFocus: true,
        name: "email",
        domain: domain,
        disabled: isLoading
      }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
        name: "email"
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        size: "sm",
        color: "secondary",
        className: "mr-2 w-32",
        onClick: onClose
      }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        size: "sm",
        className: "w-32",
        disabled: !(0, _isEmpty["default"])(errors) || !dirty || isLoading,
        onClick: handleSubmit
      }, t('button.confirm'))));
    }
  });
};
var _default = exports["default"] = ConvertForm;
var ConvertConfirm = exports.ConvertConfirm = function ConvertConfirm(_ref3) {
  var originalEmail = _ref3.originalEmail,
    customEmail = _ref3.customEmail,
    onConfirm = _ref3.onConfirm;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-10"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-center mb-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-4 rounded-full border-primary border-4 text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_Check["default"], {
    style: {
      fontSize: '4rem'
    }
  }))), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-3xl font-bold mb-4 text-center"
  }, t('settings.customDomain.convertEmail.confirm.title')), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-light font-semibold text-center mb-8"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "mb-2"
  }, t('settings.customDomain.convertEmail.confirm.warning')), /*#__PURE__*/_react["default"].createElement("p", {
    className: "break-all"
  }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
    i18nKey: "settings.customDomain.convertEmail.confirm.description",
    values: {
      originalEmail: originalEmail,
      customEmail: customEmail
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary font-bold"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-56",
    onClick: onConfirm
  }, t('button.okayGotIt'))));
};
var ConvertPlaceholder = exports.ConvertPlaceholder = function ConvertPlaceholder(props) {
  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation3.t;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, props, {
    size: "sm",
    className: "w-64 text-sm"
  }), t('settings.customDomain.convertEmail.button'))), /*#__PURE__*/_react["default"].createElement("img", {
    className: "h-56",
    src: t('custom-domain-new-email.png'),
    alt: "custom-domain-new-email"
  }));
};
//# sourceMappingURL=ConvertEmail.js.map